module.exports = __webpack_public_path__ + "images/external_images/svg/icons/048-web development.svg";